import { atom } from "kho";
import type { Object3D } from "three";

/**
 * Bridge factories bound by the Viewer — the editor keeps IFC (not GLB
 * templates), so instancesSystem builds meshes through the client's async IFC
 * loader instead of poc/editor's synchronous templateById().create().
 */

/** Build a display object for an IFC url (async, worker-parsed + cached). */
export const $ifcFactory = atom<((url: string) => Promise<Object3D | null>) | null>(
  null,
);

/** Uniform scale applied to placed objects. */
export const $objectScale = atom<number>(1);
